import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartData,
  ChartOptions,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { ForwardedRef, forwardRef } from "react";
import { Chart, ChartProps as ReactChartJsProps } from "react-chartjs-2";
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types";

ChartJS.register(
  RadialLinearScale,
  CategoryScale,
  LinearScale,
  ArcElement,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Title,
  BarElement,
  ChartDataLabels,
  LineController,
  BarController,
);

interface BarChartProps extends Omit<ReactChartJsProps, "type"> {
  options?: ChartOptions<"bar" | "line">;
  data: ChartData<"bar" | "line">;
  isStack?: boolean;
}

const MixedChart = forwardRef(
  (
    { options, data, isStack, ...restProps }: BarChartProps,
    ref: ForwardedRef<ChartJSOrUndefined<"bar" | "line">>,
  ) => {
    const option: ChartOptions<"bar" | "line"> = {
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: !!isStack,
        },
        y: {
          stacked: !!isStack,
        },
      },
      ...options,
    };

    return (
      <Chart ref={ref} data={data} options={option} {...restProps} type="bar" />
    );
  },
);

export default MixedChart;
